var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCulture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.942 7.8843C26.4853 4.77939 23.9284 2.40504 20.9148 2.03976C17.4446 1.67447 14.5223 3.86617 13.6091 6.97109C13.6091 7.06241 13.4264 7.06241 13.4264 6.97109C12.5132 3.86617 9.49963 1.67447 6.12075 2.03976C3.01583 2.40504 0.458838 4.77939 0.0935534 7.8843C-0.271731 10.076 0.458838 12.0851 1.82865 13.5462L13.4264 25.144C13.5178 25.2353 13.7917 25.2353 13.883 25.144L25.4808 13.5462C26.4853 12.0851 27.2159 10.076 26.942 7.8843Z",
    fill: "#E5B279"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5631 5.60127C21.6454 3.68353 18.4491 3.68353 16.4401 5.60127L23.5631 12.7243C25.5722 10.7152 25.5722 7.51901 23.5631 5.60127Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulture);
export default __webpack_public_path__ + "static/media/culture.daecf4c3f84213a063e3447044b76efb.svg";
export { ForwardRef as ReactComponent };